module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/Uncaught-SyntaxError-Unexpected-token-export-47.vue");


//////////////////
// WEBPACK FOOTER
// ./zh-CN/faq/Uncaught-SyntaxError-Unexpected-token-export.md
// module id = 741
// module chunks = 472